import ModalBody from '@/components/Modal/common/ModalBody';
import { PRIMARY } from '@/constants/color';
import { Button, Checkbox, Modal } from '@mui/material';
import { FC, useState } from 'react';
import DataAgreementContent from './DataAgreementContent';

interface DataAgreementModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DataAgreementModal: FC<DataAgreementModalProps> = ({ open, onClose, onConfirm }) => {
  const [isDataAgreementChecked, setIsDataAgreementChecked] = useState(false);
  const handleChange = () => {
    setIsDataAgreementChecked(!isDataAgreementChecked);
  };

  return (
    <Modal open={open} onClose={onClose} aria-labelledby='modal-title'>
      <ModalBody>
        <DataAgreementContent />
        <div className='flex items-start'>
          <Checkbox checked={isDataAgreementChecked} onChange={handleChange} />
          <div>
            By clicking confirm, I agree to Signing Electronically & accept the{' '}
            <span className={`font-medium text-[${PRIMARY}] text-[18px] underline`}>Terms above</span>
          </div>
        </div>
        <div className='mt-2 flex justify-end gap-[12px]'>
          <Button color='inherit' variant='outlined' onClick={onClose} size='large'>
            Close
          </Button>
          <Button
            disabled={!isDataAgreementChecked}
            color='primary'
            variant='contained'
            size='large'
            onClick={onConfirm}
          >
            Confirm
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default DataAgreementModal;
